import {useLocale, useTranslations} from 'next-intl';
import {JSX, SetStateAction, useEffect, useRef, useState} from 'react';
import {LazyImage} from '../utils/LazyImage';
import './Gallery.scss';

const Gallery = (props: any): JSX.Element => {
  const {showFull} = props;
  const t = useTranslations();
  const locale = useLocale();
  const [max, setMax] = useState(15);
  const [active, setActive] = useState(0);
  const [isPreview, setIsPreview] = useState(false);
  const domEl = useRef<any>(null);
  const [smiles, setSmiles] = useState<any[]>([]);
  let page = 1;
  let isLoading = false;
  let isInit = false;
  let enableInfinteScroll = true;
  let tempSmiles: any[] = [];
  let clock: string | number | NodeJS.Timeout | undefined;
  const fetchSmiles = async (page: number) => {
    if (isLoading) {
      const res = await fetch(
        `/api/smile/gallery?page=${page}&showFull=${showFull}`
      );
      try {
        const {data, meta} = await res.json();
        tempSmiles = [...tempSmiles, ...data];
        setSmiles(tempSmiles);
        const p = meta.pagination;
        if (p) {
          setMax(p.page < p.pageCount ? p.page * p.pageSize : p.total);
          if (data.length < p.pageSize || !showFull)
            enableInfinteScroll = false;
        }
      } catch (e: any) {
        enableInfinteScroll = false;
      }
      setTimeout(() => {
        isLoading = false;
      }, 500);
    }
  };
  const infiniteScroll = (e: any) => {
    if (
      isInit &&
      enableInfinteScroll &&
      !isLoading &&
      window.innerHeight - domEl.current?.getBoundingClientRect().bottom > -100
    ) {
      isLoading = true;
      fetchSmiles(++page);
    }
  };
  useEffect(() => {
    page = 1;
    tempSmiles = [];
    setSmiles([]);
    clearTimeout(clock);
    clock = setTimeout(() => {
      isInit = true;
      isLoading = true;
      fetchSmiles(1);
    }, 200);
    if (showFull) window.addEventListener('scroll', infiniteScroll);
    return () => window.removeEventListener('scroll', infiniteScroll);
  }, [showFull]);

  const openPreview = (i: SetStateAction<number>) => {
    setActive(i);
    setIsPreview(true);
  };
  const clickBackdrop = (e: any) => {
    if (!e.target.closest('.preview-wrapper')) {
      setIsPreview(false);
    }
  };
  return (
    <>
      <div className="gallery-container" ref={domEl}>
        {smiles.map((_, i) => {
          const imageUrl = _?.image?.url?.trim() ?? '';
          return (
            <div
              className="img fade-in-up"
              key={i}
              onClick={() => openPreview(i)}
            >
              <LazyImage
                alt="img"
                src={
                  imageUrl.startsWith('http')
                    ? imageUrl
                    : process.env.NEXT_PUBLIC_FTP_DOMAIN + imageUrl
                }
              />
            </div>
          );
        })}
      </div>
      {showFull && isPreview && (
        <div className="gallery-preview" onClick={(e) => clickBackdrop(e)}>
          <div className="close-btn" onClick={() => setIsPreview(false)}>
            <img alt="img" src={`/img/smile/gallery/icon-close.svg`} />
          </div>
          <div className="preview-wrapper">
            <div
              className="prev-btn"
              onClick={() => setActive((active - 1 >= 0 ? active : max) - 1)}
            >
              <img alt="img" src={`/img/smile/gallery/icon-next.svg`} />
              <span>{t.raw('Smile.gallery.prev')}</span>
            </div>
            <div className="preview">
              <img
                data-index={active}
                className="fade-in-up"
                src={
                  smiles[active]?.image?.url.startsWith('http')
                    ? smiles[active].image.url
                    : process.env.NEXT_PUBLIC_FTP_DOMAIN +
                      smiles[active].image.url.trim()
                }
                alt=""
              />
            </div>
            <div
              className="next-btn"
              onClick={() => setActive(active + 1 >= max ? 0 : active + 1)}
            >
              <img alt="img" src={`/img/smile/gallery/icon-next.svg`} />
              <span>{t.raw('Smile.gallery.next')}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
